import { money, fmtDate } from "@/lib/format";
import { CompanyHeader } from "@/components/PrintDocument";

const T = ({ title, head, rows }) => (
  <div className="mt-6" style={{ pageBreakInside: "avoid" }}>
    <div className="text-sm font-bold text-violet-800 mb-2 uppercase tracking-wider">{title}</div>
    <table className="w-full border-collapse text-xs">
      <thead><tr className="text-white" style={{ background: "#1E1250" }}>{head.map((h, i) => <th key={i} className={`p-1.5 ${i ? "text-right" : "text-left"}`}>{h}</th>)}</tr></thead>
      <tbody>
        {rows.map((r, i) => <tr key={i} className="border-b border-slate-200 odd:bg-slate-50">{r.map((c, j) => <td key={j} className={`p-1.5 ${j ? "text-right" : ""}`}>{c}</td>)}</tr>)}
        {!rows.length && <tr><td className="p-2 text-slate-400" colSpan={head.length}>Sin datos</td></tr>}
      </tbody>
    </table>
  </div>
);

// Reporte imprimible en blanco (PDF / impresión)
export const ReportSheet = ({ r, range, s }) => (
  <div className="bg-white text-slate-900 p-8" style={{ fontFamily: "Manrope, sans-serif" }}>
    <CompanyHeader s={s} right={<><div className="text-2xl font-extrabold" style={{ fontFamily: "Sora" }}>REPORTE</div><div className="text-xs text-slate-600 mt-1">{fmtDate(range.date_from)} — {fmtDate(range.date_to)}</div></>} />
    <div className="grid grid-cols-4 gap-3 mt-5 text-xs">
      {[["Ventas", money(r.total_sales)], ["Facturas", r.invoice_count], ["Por cobrar", money(r.receivables.total)], ["Inventario (costo)", money(r.inventory.total_cost)]].map(([l, v]) => (
        <div key={l} className="border border-slate-200 rounded-lg p-2"><div className="text-slate-500 uppercase text-[10px] font-bold">{l}</div><div className="font-bold text-sm">{v}</div></div>
      ))}
    </div>
    <T title="Ventas por mes" head={["Mes", "Total"]} rows={r.by_month.map((m) => [m.month, money(m.total)])} />
    <T title="Ventas por día" head={["Fecha", "Total"]} rows={r.by_day.map((d) => [fmtDate(d.date), money(d.total)])} />
    <T title="Productos más vendidos" head={["Artículo", "Cantidad", "Total"]} rows={r.top_products.map((p) => [p.name, p.qty, money(p.total)])} />
    <T title="Cuentas por cobrar" head={["Factura", "Cliente", "Vence", "Total", "Saldo"]} rows={r.receivables.items.map((i) => [i.number, i.client?.name || "", fmtDate(i.due_date), money(i.total, i.currency), money(i.balance, i.currency)])} />
    <T title="Estado del inventario" head={["Artículo", "Stock", "Mínimo", "Valor costo"]} rows={r.inventory.products.filter((p) => p.type !== "servicio").map((p) => [`${p.code} · ${p.name}`, p.stock, p.min_stock, money(p.stock * p.cost_price)])} />
  </div>
);
